export default "__VITE_ASSET__COJRBZRs__"